<template>
  <pos-layout>
    <div>
      <b-container class="text-left pt-4">
        <h3>Terminal Tools</h3>
        <b-card title="Export/Import">
          <b-card-text>
            Functionality allows to export or import local database
          </b-card-text>

          <b-button
            variant="primary"
            @click="exportLocalDb"
          >
            Export
          </b-button>
          <b-button
            variant="primary"
            disabled
          >
            Import
            <b-badge
              pill
              variant="warning"
            >
              SOON
            </b-badge>
          </b-button>
        </b-card>


        <b-card title="Export Payload">
          <b-card-text>
            Export last payload
          </b-card-text>
          <b-button
            @click="sendFileToServer(getLastOrder)"
            variant="primary"
          >
            Export
          </b-button>
        </b-card>

        <b-card title="Sync">
          <b-card-text>
            Sync terminal with dashboard
          </b-card-text>
          <b-button
            :to="{name: 'Synchronize'}"
            variant="primary"
          >
            Start Sync
          </b-button>
        </b-card>
        <b-card
          :to="{name: 'Reset'}"
          title="Reset"
        >
          <b-card-text>Reset dashboard settings</b-card-text>

          <b-button
            :to="{name: 'Reset'}"
            variant="primary"
          >
            Reset
          </b-button>
        </b-card>

        <b-card title="Receipt Printer Debug">
          <b-card-text>
            Test receipt printer with ESC/POS commands and example receipt
          </b-card-text>
          
          <b-button
            variant="secondary"
            :to="{name: 'PrinterTest'}"
            class="mb-2"
          >
            Advanced Printer Test Suite
          </b-button>
          
          <!-- Printer Configuration Info -->
          <div class="mb-3">
            <h6>Printer Configuration:</h6>
            <div class="small text-muted">
              <div><strong>Printer Name:</strong> {{ (terminalInfo.printer && terminalInfo.printer.name) || 'Not configured' }}</div>
              <div><strong>Printer IP:</strong> {{ (terminalInfo.printer && terminalInfo.printer.local_ip) || 'Not configured' }}</div>
              <div><strong>Printer Server IP:</strong> {{ terminalInfo.printer_server_ip || 'Not configured' }}</div>
              <div><strong>Is 58mm:</strong> {{ (terminalInfo.printer && terminalInfo.printer.is_58mm) ? 'Yes' : 'No' }}</div>
              <div><strong>QZ Tray Status:</strong> <span :class="qzTrayStatus.class">{{ qzTrayStatus.text }}</span></div>
            </div>
          </div>
          
          <b-button
            variant="success"
            @click="printDebugReceipt"
            :disabled="isPrinting"
          >
            {{ isPrinting ? 'Printing...' : 'Print Debug Receipt' }}
          </b-button>
          
          <b-button
            variant="info"
            @click="printESCPOSTest"
            :disabled="isPrinting"
            class="ml-2"
          >
            {{ isPrinting ? 'Printing...' : 'Print ESC/POS Test' }}
          </b-button>
          
          <b-button
            variant="warning"
            @click="checkQZTrayStatus"
            class="ml-2"
          >
            Check QZ Tray Status
          </b-button>

          <b-button
            variant="dark"
            @click="printFontStyleTest"
            :disabled="isPrinting"
            class="ml-2"
          >
            {{ isPrinting ? 'Printing...' : 'Print Font & Style Test' }}
          </b-button>
        </b-card>
      </b-container>
    </div>
  </pos-layout>
</template>

<script>
import PosLayout from '../layouts/PosLayout';
import indexDbService from "../helpers/dbHelper"
import DashboardService from "../services/dashboard-service";
import printMixin from '../mixins/printMixin';
import { printReceipt, printFontStyleTest } from '../helpers/printHelper';
import * as qz from 'qz-tray';

export default {
  name: 'Tools',
  components: {
    PosLayout
  },
  mixins: [printMixin],
  data() {
    return {
      isPrinting: false,
      qzTrayConnected: false
    };
  },
  mounted() {
    this.checkQZTrayStatusOnLoad();
  },
  computed: {
    terminalInfo() {
      return this.$store.getters["config/terminal"];
    },
    qzTrayStatus() {
      if (this.qzTrayConnected) {
        return { text: 'Connected', class: 'text-success' };
      } else {
        return { text: 'Disconnected', class: 'text-danger' };
      }
    },
    getLastOrder(){
      const orders = this.$store.getters["orders/getAllOrders"];
      const ordersToSync = orders.filter(order => 
        ((!order.id && order.local_id) || 
        (
         new Date(order.updated_at).getTime() >= new Date(order.synced_at).getTime() && 
         order.updated === true))
      );
      if (ordersToSync && ordersToSync.length > 0) {
        return ordersToSync;
      }
      

      
      return [];
    }
  },  
  methods: {
    async exportLocalDb() {
      try {
        // TODO
        // const res = await exportToJson();
        // Full DB export: every order regardless of status is required, so this
        // intentionally stays on getDbData and not the Phase 5 status index.
        const orders = await indexDbService.getDbData('orders');
        let dataToSave = {}
        try {
          dataToSave = orders
        } catch (e){
          console.error("could not retrieve orders from storage");
        }
        this.saveFile(dataToSave);
      } catch (e) {
        console.error(e)
        await this.$store.dispatch('errorModal/displayModalError', {
          modalId: 'print-error',
          errorBody: {
            title: 'Error',
            info: 'Something went wrong during export! Please, contact administrator'
          }
        });
      }

    },

  async agetPresignedUrl() {
    const terminalId = this.$store.getters["config/terminal"].id;
    const subDomain = window.location.host.split('.')[0];
    
    const now = new Date();
    const isoTimestamp = now.toISOString().replace(/[:]/g, '_').replace(/\..+/, '') + 'Z'; 
 
   const response = await DashboardService.postPresignedUrl({file_name:`${subDomain}_${terminalId}_${isoTimestamp}`});
 
   return response;
 },
 

async uploadDataToS3(presignedData, fileBlob) {
  const formData = new FormData();

  Object.entries(presignedData.fields).forEach(([key, value]) => {
    formData.append(key, value);
  });

  formData.append('file', fileBlob);

  const res = await fetch(presignedData.url, {
    method: 'POST',
    body: formData
  });

  if (!res.ok) {
    throw new Error("Upload failed");
  }
},


  async sendFileToServer(res) {
    const data = JSON.stringify(res);
    const blob = new Blob([data], { type: 'application/json' });
    const FileSaver = require('file-saver');
    FileSaver.saveAs(blob, 'terminalOrdersDump.json');

    try {
      const presignedResponse = await this.agetPresignedUrl();
    await this.uploadDataToS3(presignedResponse.presigned_url, blob); 
    } catch (err) {
      console.error("Upload to S3 failed", err);
    }
  },
  async saveFile(res) {
    const data = JSON.stringify(res);
    const blob = new Blob([data], { type: 'application/json' });
    const FileSaver = require('file-saver');
    FileSaver.saveAs(blob, 'terminalOrdersDump.json');
  },

  async printDebugReceipt() {
    this.isPrinting = true;
    
    try {
      // Check QZ Tray status first
      if (!qz.websocket.isActive()) {
        const terminalInfo = this.$store.getters["config/terminal"];
        const connectOptions = terminalInfo.printer_server_ip ? { host: terminalInfo.printer_server_ip } : {};
        await qz.websocket.connect(connectOptions);
        this.qzTrayConnected = true;
      }
      
      const debugOrder = this.createDebugOrder();
      
      await printReceipt(debugOrder);
      
      this.$bvToast.toast('Debug receipt printed successfully!', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
      
    } catch (error) {
      console.error('Print error details:', error);
      console.error('Error stack:', error.stack);
      
      this.$bvToast.toast('Failed to print debug receipt: ' + error.message, {
        title: 'Error',
        variant: 'danger',
        solid: true
      });
    } finally {
      this.isPrinting = false;
    }
  },

  createDebugOrder() {
    // Create a debug order object that mimics a real order structure
    const currentDate = new Date();
    const terminalInfo = this.$store.getters["config/terminal"];
    
    return {
      id: "DEBUG-" + Date.now(),
      local_id: "debug-" + Date.now(),
      table: null, // No table for debug orders
      status: 0, // PENDING status
      open_date: currentDate.toISOString(),
      updated_at: currentDate.toISOString(),
      synced_at: currentDate.toISOString(),
      updated: false,
      receipt_kitchen_printed: false,
      related_terminal: terminalInfo.id,
      items: [
        {
          id: "debug-item-1",
          product: "Debug Product 1",
          name: "Debug Test Item 1",
          quantity: 1,
          price: 10.00,
          subtotal: 10.00, // Required for printReceipt
          total: 10.00,
          void_status: 0,
          sent_to_kitchen: false,
          has_kitchen_updates: false,
          printers: [],
          modifiers: []
        },
        {
          id: "debug-item-2", 
          product: "Debug Product 2",
          name: "Debug Test Item 2",
          quantity: 2,
          price: 15.50,
          subtotal: 31.00, // Required for printReceipt
          total: 31.00,
          void_status: 0,
          sent_to_kitchen: false,
          has_kitchen_updates: false,
          printers: [],
          modifiers: []
        }
      ],
      // Required properties for printReceipt function (must be numbers)
      subtotal: 41.00,
      discount_total: 0.00,
      tax_total: 3.28,
      grand_total: 44.28,
      surcharge_value: 0.00,
      discount_orders: 0.00,
      payments: [
        {
          amount: 44.28,
          change_amount: 0.00,
          method: "cash",
          type: "cash"
        }
      ],
      customer: {
        first_name: "Debug",
        last_name: "Customer",
        phone: "123-456-7890",
        email: "debug@test.com"
      },
      payment_method: "cash",
      cashier: this.$store.getters["employee"]?.name || "Debug Cashier"
    };
  },

  async printESCPOSTest() {
    this.isPrinting = true;
    
    try {
      // Check QZ Tray status first
      if (!qz.websocket.isActive()) {
        const terminalInfo = this.$store.getters["config/terminal"];
        const connectOptions = terminalInfo.printer_server_ip ? { host: terminalInfo.printer_server_ip } : {};
        await qz.websocket.connect(connectOptions);
        this.qzTrayConnected = true;
      }
      
      const debugOrder = this.createESCPOSTestOrder();
      
      await printReceipt(debugOrder);
      
      this.$bvToast.toast('ESC/POS test printed successfully!', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
      
    } catch (error) {
      console.error('ESC/POS test error details:', error);
      console.error('Error stack:', error.stack);
      
      this.$bvToast.toast('Failed to print ESC/POS test: ' + error.message, {
        title: 'Error',
        variant: 'danger',
        solid: true
      });
    } finally {
      this.isPrinting = false;
    }
  },

  createESCPOSTestOrder() {
    // Create a debug order specifically for ESC/POS command testing
    const currentDate = new Date();
    const terminalInfo = this.$store.getters["config/terminal"];
    
    return {
      id: "ESC-POS-TEST-" + Date.now(),
      local_id: "escpos-test-" + Date.now(),
      table: null, // No table for debug orders
      status: 0,
      open_date: currentDate.toISOString(),
      updated_at: currentDate.toISOString(),
      synced_at: currentDate.toISOString(),
      updated: false,
      receipt_kitchen_printed: false,
      related_terminal: terminalInfo.id,
      items: [
        {
          id: "escpos-test-item",
          product: "ESC/POS Test",
          name: "=== ESC/POS COMMAND TEST ===",
          quantity: 1,
          price: 0.00,
          subtotal: 0.00, // Required for printReceipt
          total: 0.00,
          void_status: 0,
          sent_to_kitchen: false,
          has_kitchen_updates: false,
          printers: [],
          modifiers: []
        }
      ],
      // Required properties for printReceipt function (must be numbers)
      subtotal: 0.00,
      discount_total: 0.00,
      tax_total: 0.00,
      grand_total: 0.00,
      surcharge_value: 0.00,
      discount_orders: 0.00,
      payments: [
        {
          amount: 0.00,
          change_amount: 0.00,
          method: "test",
          type: "test"
        }
      ],
      customer: null,
      payment_method: "test",
      cashier: "ESC/POS Test"
    };
  },

  async printFontStyleTest() {
    this.isPrinting = true;
    try {
      await printFontStyleTest();
      this.$bvToast.toast('Font & style test printed!', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    } catch (error) {
      console.error('Font style test print error:', error);
      this.$bvToast.toast('Failed to print font test: ' + error.message, {
        title: 'Error',
        variant: 'danger',
        solid: true
      });
    } finally {
      this.isPrinting = false;
    }
  },

  async checkQZTrayStatusOnLoad() {
    try {
      this.qzTrayConnected = qz.websocket.isActive();
    } catch (error) {
      console.error('Error checking QZ Tray status on load:', error);
      this.qzTrayConnected = false;
    }
  },

  async checkQZTrayStatus() {
    try {
      const terminalInfo = this.$store.getters["config/terminal"];
      const connectOptions = terminalInfo.printer_server_ip ? { host: terminalInfo.printer_server_ip } : {};
      
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect(connectOptions);
        this.qzTrayConnected = true;
        this.$bvToast.toast('QZ Tray connected successfully!', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
      } else {
        this.qzTrayConnected = true;
        this.$bvToast.toast('QZ Tray is already connected', {
          title: 'Info',
          variant: 'info',
          solid: true
        });
      }
    } catch (error) {
      console.error('QZ Tray connection error:', error);
      this.qzTrayConnected = false;
      this.$bvToast.toast('Failed to connect to QZ Tray: ' + error.message, {
        title: 'Error',
        variant: 'danger',
        solid: true
      });
    }
  }
}


};
</script>
